<template>
  <div class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <el-row class="flex">
        <selectStandardId @updateStandardId="updateStandardId" />
        <el-input
          clearable
          v-model="searchName"
          class="w-200px mr-10px ml-10px"
          size="small"
          placeholder="规则名称"
        ></el-input>
        <el-date-picker
          v-model="datetimerange"
          size="small"
          class="mr-10px"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
        <el-button @click="getAppList" size="small" type="primary">搜索</el-button>
        <el-button @click="reset" size="small">重置</el-button>
        <el-button
          :disabled="!$hasAccess('create')"
          size="small"
          type="primary"
          @click="clickAddApplication"
          >新增</el-button
        >
        <el-button :disabled="!$hasAccess('delete')" size="small" type="danger" @click="clickDelete"
          >删除</el-button
        >
        <el-button
          :disabled="!$hasAccess('export')"
          size="small"
          @click="exportApplication"
          :loading="exportLoading"
          >导出</el-button
        >
      </el-row>
      <el-table
        v-loading="tableLoading"
        border
        @selection-change="changeSelected"
        height="calc(100% - 106px)"
        :data="applicationList"
        ref="multipleTable"
        class="mt-20px"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip prop="roleNames" label="角色"></el-table-column>
        <el-table-column show-overflow-tooltip prop="className" label="实体名称"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="classAttributeName"
          label="属性"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="ruleName"
          label="脱敏规则名称"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="ruleExpression"
          label="规则表达式"
        ></el-table-column>
        <el-table-column show-overflow-tooltip prop="ruleRemark" label="备注"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="createdTime"
          label="创建时间"
        ></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              :disabled="!$hasAccess('read')"
              @click.stop="clickOperate(scope.row, 'view')"
              size="mini"
              >{{ $t('view') }}</el-button
            >
            <el-button
              :disabled="!$hasAccess('update')"
              @click.stop="clickOperate(scope.row, 'edit')"
              size="mini"
              >{{ $t('edit') }}</el-button
            >
            <el-button
              :disabled="!$hasAccess('delete')"
              @click.stop="clickDeleteItem(scope.row)"
              size="mini"
              >{{ $t('delete') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        @current-change="getAppList"
        @size-change="getAppList"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next, jumper"
        :total="recordCount"
      ></el-pagination>

      <el-dialog
        @close="clickCancel"
        :title="dialogTitle"
        class="small-dialog"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        v-dialogDrag
      >
        <el-form
          ref="form"
          :model="formData"
          :rules="formRules"
          label-width="120px"
          label-position="right"
        >
          <el-row>
            <el-col>
              <el-form-item label="规则" prop="ruleId">
                <el-select
                  :disabled="readMode"
                  class="form-input"
                  v-model="formData.ruleId"
                  @change="changeRule"
                  size="small"
                >
                  <el-option
                    v-for="item in ruleOption"
                    :key="item.id"
                    :label="item.ruleName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col>
              <el-form-item label="备注">
                <el-input
                  readonly
                  v-model="formData.ruleRemark"
                  class="form-input"
                  size="small"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="角色" prop="roleIds">
                <el-select
                  @change="changeCharactor"
                  :disabled="readMode"
                  class="form-input"
                  v-model="formData.roleIds"
                  size="small"
                  :multiple-limit="10"
                  multiple
                  collapse-tags
                >
                  <el-option
                    v-for="item in charatorList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="实体">
                <el-select
                  :disabled="readMode"
                  filterable
                  @change="changeClassId"
                  class="form-input"
                  v-model="formData.classId"
                  size="small"
                >
                  <el-option
                    v-for="item in classList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="属性">
                <el-select
                  :disabled="readMode"
                  class="form-input"
                  v-model="formData.classAttributeId"
                  size="small"
                >
                  <el-option
                    v-for="item in attrbuteList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer tc" v-if="!readMode">
          <el-button size="small" type="primary" :loading="saveLoading" @click="confirmOperate"
            >保存</el-button
          >
          <el-button @click="clickCancel" size="small">取消</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import DesensitizationService from '@/services/Desensitization'
import stdClassListService from '@/services/stdClassListService'
import fnMixin from '@/assets/js/fnMixins'
import selectStandardId from '../../components/selectStandardId'

export default {
  components: { selectStandardId },
  async created() {
    this.getCharactor()
    this.getRuleList()
    if (this.standardId) {
      this.getAppList()
      this.getClassList()
    }
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
  data() {
    return {
      searchName: '',
      datetimerange: [],
      applicationList: [],
      tableLoading: false,
      selectedItems: [],
      pageNo: 1,
      pageSize: 10,
      recordCount: 0,
      dialogTitle: '新增规则应用',
      dialogVisible: false,
      formData: {
        ruleId: '',
        roleIds: '',
        ruleRemark: '',
        classId: '',
        classAttributeId: '',
      },
      formRules: {
        ruleId: [{ required: true, message: '请输入规则', trigger: 'blur' }],
        roleIds: [{ required: true, message: '请输入角色', trigger: 'blur' }],
      },
      ruleOption: [],
      charatorList: [],
      classList: [],
      attrbuteList: [],
      readMode: false,
      operateMode: 'create',
      operateItem: null,
      roleName: [],
      exportLoading: false,
      standardId: localStorage.getItem('standardId'),
      saveLoading: false,
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
    }
  },
  watch: {
    standardId: {
      handler(newVal) {
        if (newVal) {
          this.getAppList()
          this.getClassList()
        }
      },
    },
  },
  methods: {
    updateStandardId(val) {
      this.standardId = val
    },
    changeCharactor(itemList) {
      this.roleName = []
      _.forEach(itemList, (i) => {
        if (_.find(this.charatorList, ['id', i])) {
          this.roleName.push(_.find(this.charatorList, ['id', i]).name)
        }
      })
    },

    changeRule(val) {
      const findItem = _.find(this.ruleOption, ['id', val])
      if (findItem) {
        this.formData.ruleRemark = findItem.remark
      }
    },

    reset() {
      this.datetimerange = []
      this.searchName = ''
      this.getAppList()
    },

    /**
     * @description 导出
     */
    async exportApplication() {
      const ids = _.map(this.selectedItems, (i) => {
        return i.id
      })
      const params = {
        ruleName: this.searchName,
        startDate: this.datetimerange && this.datetimerange[0] ? this.datetimerange[0] : '',
        endDate: this.datetimerange && this.datetimerange[1] ? this.datetimerange[1] : '',
        ids,
        standardId: this.standardId,
      }
      this.exportLoading = true
      const res = await DesensitizationService.exportDataDesensitizationApp(params)
      this.exportLoading = false
      if (res) {
        const time = fnMixin.methods.getNowTime()
        fnMixin.methods.downLoadExcel(`数据脱敏应用${time}`, res)
      }
    },

    /**
     * @function 删除单行
     * @param {Object} item 选择行
     */
    clickDeleteItem(item) {
      this.$confirm('是否确定要删除该数据', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const ids = [item.id]
        const res = await DesensitizationService.deleteApplication(ids)
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: res.msg,
          })
          this.getAppList()
        }
      })
    },

    /**
     * @function 点击操作
     * @param {Object} item 操作行
     * @param {String} type 操作类型
     */
    async clickOperate(item, type) {
      this.dialogVisible = true

      this.formData = _.cloneDeep(item)
      this.formData.roleIds = this.formData.roleIds.split(',')
      this.operateMode = type
      await this.getAttrList()
      if (type === 'view') {
        this.dialogTitle = '查看规则应用'
        this.readMode = true
      } else if (type === 'edit') {
        this.dialogTitle = '编辑规则应用'
        this.operateItem = item
        _.forEach(this.formData.roleIds, (i) => {
          if (_.find(this.charatorList, ['id', i])) {
            this.roleName.push(_.find(this.charatorList, ['id', i]).name)
          }
        })
        this.readMode = false
      }
    },

    /**
     * @function 获取属性列表
     */
    async getAttrList() {
      if (!this.formData.classId) return
      const parameter = {
        class_id: this.formData.classId,
      }
      const res = await stdClassListService.getAttrList(parameter)
      if (res && res.code === 0 && res.data) {
        this.attrbuteList = res.data
      }
    },
    /**
     * @function 修改类别id
     */
    changeClassId() {
      this.formData.classAttributeId = ''
      this.getAttrList()
    },
    /**
     * @function 获取实体列表
     */
    async getClassList() {
      this.classListLoading = true
      const parameter = {
        standard_id: this.standardId,
        data_type: 1,
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classList = res.data
      }
    },

    /**
     * @function 获取角色
     */
    async getCharactor() {
      const fileServer = Wiz.GetModuleServer('system-management')
      const res = await axios.get(`${fileServer}/api/identity/roles?SkipCount=0&MaxResultCount=999`)
      if (res && res.data && res.status === 200) {
        this.charatorList = res.data.items
      }
    },

    /**
     * @function 获取规则列表
     */
    async getRuleList() {
      const params = {
        SkipCount: 1,
      }
      const res = await DesensitizationService.getList(params)
      if (res && res.code === 0 && res.data) {
        this.ruleOption = res.data
      }
    },

    /**
     * @function 获取列表
     */
    async getAppList() {
      const param = {
        SkipCount: this.pageNo,
        MaxResultCount: this.pageSize,
        Sorting: '',
        RuleName: this.searchName,
        StartDate: this.datetimerange && this.datetimerange[0] ? this.datetimerange[0] : '',
        EndDate: this.datetimerange && this.datetimerange[1] ? this.datetimerange[1] : '',
        StandardId: this.standardId,
      }
      this.tableLoading = true
      const res = await DesensitizationService.getAppList(param)
      this.tableLoading = false
      if (res && !_.isEmpty(res.data) && res.code === 0) {
        this.applicationList = res.data
        this.recordCount = res.totalCount
      } else {
        this.applicationList = []
        this.recordCount = 0
      }
    },

    /**
     * @function 点击删除
     */
    clickDelete() {
      const ids = _.map(this.selectedItems, (i) => {
        return i.id
      })
      if (!ids.length) {
        this.$message({
          type: 'warning',
          message: '请选择要删除的数据',
        })
        return
      }
      this.$confirm('是否确定要删除该数据', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await DesensitizationService.deleteApplication(ids)
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: res.msg,
            })
            this.getAppList()
          }
        })
        .catch()
    },

    /**
     * @function 确认编辑
     */
    confirmOperate() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const parameter = _.cloneDeep(this.formData)
          parameter.roleIds = parameter.roleIds.join(',')
          parameter.roleNames = this.roleName.join(',')
          parameter.standardId = this.standardId
          this.saveLoading = true
          if (this.operateMode === 'create') {
            const res = await DesensitizationService.createApplication(parameter)
            if (res && res.code === 0 && res.data) {
              this.saveLoading = false
              this.$message({
                type: 'success',
                message: res.msg,
              })
              this.clickCancel()
              this.getAppList()
            }
          } else if (this.operateMode === 'edit') {
            const res = await DesensitizationService.editApplication(parameter)
            if (res && res.code === 0 && res.data) {
              this.saveLoading = false
              this.$message({
                type: 'success',
                message: res.msg,
              })
              this.clickCancel()
              this.getAppList()
            }
          }
        }
      })
    },

    /**
     * @function 点击新增
     */
    clickAddApplication() {
      this.dialogTitle = '新增规则应用'
      this.operateMode = 'create'
      this.dialogVisible = true
      this.readMode = false
    },

    /**
     * @function 点击取消
     */
    clickCancel() {
      this.$refs.form.resetFields()
      this.formData = this.$options.data().formData
      this.dialogVisible = false
    },

    changeSelected(item) {
      this.selectedItems = item
    },
  },
}
</script>

<style lang="scss" scoped>

.w-200 {
  width: 200px;
}
.form-input {
  width: 300px;
}

</style>
